module.exports = __webpack_public_path__ + "img/复活节兔子灯-2.5ae716d0.jpg";